import React from 'react';

import styles from './Icon.module.css';

import shopIcon from '../img/shop.png'
import cartIcon from '../img/cart.png'
import accountIcon from '../img/account.png'
import helpIcon from '../img/help.png'

type IconProps = {
    kind: 'cart' | 'account' | 'shop' | 'help' | 'none',
    className?: string
}

export const Icon: React.FC<IconProps> = ({ kind, className = '' }) => {
    return (
        <img className={`${styles.icon} ${className}`}
            src={getIconSrcByKind(kind)} alt='icon' />
    );
}

function getIconSrcByKind(kind: IconProps['kind']): string {
    switch (kind) {
        case 'cart': return cartIcon;
        case 'shop': return shopIcon;
        case 'account': return accountIcon;
        case 'help': return helpIcon;
        default: {
            console.error(`Not found image source by kind ${kind}`);
            return '';
        }
    }
}